export default {
  common: {
    loading: "載入中...",
    cancel: "取消",
    confirm: "確定",
    noMore: "沒有更多資料了",
    loadMore: "上拉載入更多",
    loadingMore: "載入更多...",
    refreshSuccess: "刷新成功",
    refreshFailed: "刷新失敗",
    landscapeTip: "請將手機豎屏使用以獲得更好的體驗",
    submit: "提交",
    all: "全部",
    language: "語言",
  },
  tabBar: {
    home: "首頁",
    notice: "訊息",
    profile: "我的",
  },
  notice: {
    title: "訊息通知",
    tabs: {
      notification: "通知",
      reply: "回復我的",
      mention: "{'@'}我的",
      like: "點讚",
    },
    replyComment: "{username} 回復了你的評論",
    replyPost: "{username} 回復了你的帖子",
    mentionComment: "{username} {'@'}了你的評論",
    mentionPost: "{username} {'@'}了你的帖子",
    likeComment: "{username} 點讚了你的評論",
    likePost: "{username} 點讚了你的帖子",
    system: "系統通知",
    empty: "暫無訊息",
  },
  home: {
    gameName: "Puzzles & Survival",
    unboundRole: "未綁定角色",
    pleaseLogin: "請先登入帳號",
    loginNow: "登入",
    loginInSuccess: "登錄成功",
    signIn: "簽到",
    hasSigned: "已簽到",
    signInFailedTip: "簽到失敗，請稍後再試",
    signSuccess: "簽到成功",
    signFailed: "簽到失敗",
    goToShop: "前往積分中心",
    pullToRefresh: "下拉刷新",
    releaseToRefresh: "釋放刷新",
    sortByTime: "最新",
    sortByLastPost: "最近評論",
    tags: {
      recommend: "推薦",
      chats: "交流",
      guide: "攻略",
      activity: "活動",
      news: "新聞",
    },
  },
  post: {
    title: "帖子",
    create: {
      title: "發帖",
      submit: "發布",
      titlePlaceholder: "請填寫標題",
      contentPlaceholder: "這刻你想說的...",
      image: "圖片",
      video: "視頻",
      mention: "{'@'}",
      selectBoard: "選擇板塊",
      topicLabel: "話題",
      imageSizeLimit: "圖片大小不能超過5MB",
      videoSizeLimit: "視頻大小不能超過50MB",
      titleEmpty: "標題不能為空",
      contentEmpty: "內容不能為空",
      submitting: "發布中...",
      success: "發布成功",
      failed: "發布失敗",
      imageUploading: "圖片上傳中，請稍候...",
      imageUploadSuccess: "圖片上傳成功",
      imageUploadFailed: "圖片上傳失敗",
      videoUploading: "視頻上傳中，請稍候...",
      videoUploadSuccess: "視頻上傳成功",
      videoUploadFailed: "視頻上傳失敗",
      maxCharsReached: "已達到最大字元數限制 ({max} 字元)",
      invalidFileType: "不支援的檔案類型",
      fileTooLarge: "檔案大小超過限制（最大 {maxSize}）",
    },
  },
  postDetail: {
    writeSomething: "說點什麼...",
    sending: "發送中...",
    sendSuccess: "發送成功",
    sendFailed: "發送失敗",
    loadFailed: "載入失敗",
    noContent: "暫無內容",
    allReplies: "全部回復",
    onlyAuthor: "只看作者",
    earliest: "最早回復",
    latest: "最新回復",
    allComments: "全部{num}條回復",
    replyTo: "回復",
    author: "作者",
    floor: "樓",
    reply: "回復",
    favoriteSuccess: "收藏成功",
    cancelFavorite: "已取消收藏",
    viewOriginalPost: "查看原帖",
    commentTooShort: "評論內容不能少於5個字",
    translate: "翻譯",
    translating: "翻譯中...",
    translateSuccess: "翻譯成功",
    translateFailed: "翻譯失敗",
    translatedTo: "已翻譯為",
  },
  operateModal: {
    title: "操作",
    copyLink: "複製連結",
    delete: "刪除",
    shareToGame: "分享到遊戲內",
    copySuccess: "複製成功",
    confirmDelete: "確定要刪除這個帖子嗎？",
    deleteSuccess: "刪除成功",
    deleteFailed: "刪除失敗",
    copyFailed: "複製失敗",
  },
  shareModal: {
    selectChannelTitle: "請選擇分享到的頻道",
    channelLabel: "頻道",
    channelPlaceholder: "請選擇頻道",
    alliance: "聯盟",
    shareSuccess: "分享成功",
    continueBrowse: "繼續瀏覽",
    goToGame: "前往遊戲查看",
    noThreadTip: "請先在帖子詳情頁操作",
  },
  profile: {
    title: "個人中心",
    editNickname: "修改暱稱",
    communityId: "社區ID",
    followers: "粉絲",
    follow: "追蹤",
    followSuccess: "關注成功",
    unfollowSuccess: "取消關注成功",
    addLikeSuccess: "點讚成功",
    cancelLikeSuccess: "取消點讚成功",
    likes: "獲讚",
    tabs: {
      posts: "我的動態",
      favorites: "我的收藏",
    },
    followed: "已關注",
    noPosts: "暫無動態",
    noFavorites: "暫無收藏",
    shopLabel: "積分商城",
  },
  search: {
    btn: "搜尋",
    hotTitle: "熱搜",
    historyTitle: "歷史搜尋",
    tabs: {
      post: "貼文",
      user: "用戶",
    },
    empty: "無相關搜尋內容",
    filter: {
      title: "排序",
      views: "熱門",
      dateline: "最新",
    },
    relatedPosts: "相關帖子",
  },
  nicknameModify: {
    placeholder: "請輸入暱稱",
    myCoins: "我的積分：",
    getMore: "獲取",
    description: "修改暱稱需花費50積分，每月首次修改免費",
    alreadyRenamed: "每月只能修改一次暱稱，您本月已經修改過了",
    sameNickname: "暱稱不能與當前暱稱相同",
    coinNotEnough: "積分不足",
    nicknameTooShort: "暱稱不能少於3個字",
    viewRecord: "查看修改記錄",
    recordTitle: "修改記錄",
    date: "日期",
    changedNickname: "更改暱稱",
    cost: "消耗",
    success: "修改成功",
  },
  shop: {
    title: "兌換中心",
    record: "兌換記錄",
    emptyTip: "商舖正在搭建，敬請期待~",
    bindRole: "綁定角色",
    switchRole: "更換角色",
    tabs: {
      tasks: "積分任務",
      rewards: "獎勵兌換",
    },
    taskInProgress: "進行中",
    taskCompleted: "已完成",
    goToComplete: "去完成",
    exchange: "兌換",
    exchanged: "已兌換",
    exchangeConfirmTitle: "是否兌換獎勵？",
    currentCoins: "當前積分",
    costCoins: "消耗積分",
    receiveRole: "領取角色",
    exchangeSuccess: "兌換成功",
    exchangeFailed: "兌換失敗",
  },
  exchangeRecord: {
    time: "時間",
    content: "內容",
    points: "積分",
    empty: "暫無兌換記錄",
  },
  setting: {
    title: "設定",
    about: "關於我們",
    service: "服務條款",
    privacy: "隱私政策",
    logout: "退出登錄",
    logoutSuccess: "已退出登錄",
  },
  avatar: {
    title: "修改頭像",
  },
  commentModal: {
    title: "評論",
    placeholder: "寫評論...",
    replyTo: "回復{username}",
  },
  bindRole: {
    title: "綁定角色",
    modifyTitle: "修改綁定角色",
    server: "伺服器：",
    role: "角色名：",
    serverPlaceholder: "請選擇伺服器",
    rolePlaceholder: "請選擇角色",
    bindSuccess: "角色綁定成功",
    bindFailed: "角色綁定失敗",
    getServerListFailed: "獲取伺服器列表失敗",
    getRoleListFailed: "獲取角色列表失敗",
    noRole: "暫無角色",
    recentServers: "您的伺服器",
    allServers: "全部伺服器",
  },
  mentionModal: {
    title: "選擇用戶",
    searchPlaceholder: "搜尋用戶",
  },
  linkModal: {
    title: "插入連結",
    viewTitle: "查看連結",
    textLabel: "連結文字",
    textPlaceholder: "請輸入連結文字",
    urlLabel: "連結地址",
    urlPlaceholder: "請輸入連結地址",
    close: "關閉",
  },
  time: {
    minutesAgo: "{minutes}分鐘前",
    hoursAgo: "{hours}小時前",
  },
  maintenance: {
    title: "頁面維護中",
    message: "抱歉，當前遊戲論壇正在維護中，請稍後再試。",
  },
  error: {
    common: "操作失敗，請稍後再試",
    50002: "Token無效或過期",
    50301: "您沒有發帖權限",
    50302: "發帖次數已達上限",
    50303: "內容長度不符合要求",
    50304: "內容包含敏感詞，請修改後重試",
    50308: "您沒有權限查看此帖子",
    50309: "帖子已被刪除或移動",
    50351: "主題帖已關閉，無法回復",
    50353: "您沒有回復權限",
    50354: "本板塊禁止回復",
    50355: "發帖過於頻繁，請稍後再試",
    50356: "每小時發帖數量已達上限",
    50361: "評論不存在",
    50500: "您沒有搜尋權限",
    50501: "搜尋功能已關閉",
    50502: "內容包含敏感詞，請修改後重試",
    50006: "該暱稱已被其他用戶使用",
    50007: "每月只能修改一次暱稱，您本月已經修改過了",
    50008: "積分不足",
    50505: "搜尋過於頻繁，請稍後再試",
    50703: "圖片審核不通過",
    50704: "圖片內容不符合規範",
    50214: "分享失敗，未加入@:shareModal.alliance",
  },
};
